

































































































































import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import { ModuleNames } from '@/store/module-names'
import { GetterNames as ExerciseProgramGetterNames } from '@/store/modules/exercise-program/keys'
import { UserActionContexts } from '@/constants/urls'
import { PatientManagementWizardDetailedPatientInformationKeys as PatientInformationKeys } from '@/constants/patients'

export default {
  components: {},

  props: {
    patientInformationIsValid: {
      type: Boolean,
      required: true,
    },
    [PatientInformationKeys.FirstName]: {
      type: String,
      default: '',
    },
    [PatientInformationKeys.LastName]: {
      type: String,
      default: '',
    },
    [PatientInformationKeys.DateOfBirth]: {
      type: String,
      default: '',
    },
    [PatientInformationKeys.PhoneNumber]: {
      type: String,
      default: '',
    },
    [PatientInformationKeys.CareGiver]: {
      type: Object,
      default: null,
    },
    [PatientInformationKeys.AvailableCareGivers]: {
      type: Array,
      default: null,
    },
    [PatientInformationKeys.InhalerType]: {
      type: String,
      default: '',
    },
    [PatientInformationKeys.Program]: {
      type: String,
      default: '',
    },
    patientNoun: {
      type: String,
      required: true,
    },
    userActionContext: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      PatientInformationKeys: {
        firstName: PatientInformationKeys.FirstName,
        lastName: PatientInformationKeys.LastName,
        dateOfBirth: PatientInformationKeys.DateOfBirth,
        phoneNumber: PatientInformationKeys.PhoneNumber,
        careGiver: PatientInformationKeys.CareGiver,
        availableCareGivers: PatientInformationKeys.AvailableCareGivers,
        inhalerType: PatientInformationKeys.InhalerType,
        program: PatientInformationKeys.Program,
      },
      isRequiredFieldRule: [v => !!v || 'This information is required'],
    }
  },

  computed: {
    contextIsNew() {
      return this.userActionContext === UserActionContexts.New
    },
    contextIsEdit() {
      return this.userActionContext === UserActionContexts.Edit
    },
    stageDescriptionText() {
      if (this.contextIsNew) {
        return `Create a profile for your new ${this.patientNoun.toLowerCase()}. Add the ${this.patientNoun.toLowerCase()}'s personal information, package ID, and other medical information.`
      } else {
        return `Edit the profile for your ${this.patientNoun.toLowerCase()}. Change the ${this.patientNoun.toLowerCase()}'s personal information, package ID, and other medical information as needed.`
      }
    },
    formattedDateOfBirth() {
      if (this[PatientInformationKeys.DateOfBirth]) {
        return moment(this[PatientInformationKeys.DateOfBirth]).format('DD-MM-YYYY')
      }
      return ''
    },
    careGiverOptions() {
      if (this[PatientInformationKeys.AvailableCareGivers]) {
        let cg = this[PatientInformationKeys.AvailableCareGivers]
        return [...cg].sort((a, b) => (a.firstName > b.firstName ? 1 : a.firstName < b.firstName ? -1 : 0))
      }
      return []
      // return ['Martha Flannery', 'Brian Badonde']
    },
    inhalerTypeOptions() {
      return [
        {
          label: 'Preventer',
          value: 'preventer',
        },
        {
          label: 'Reliever',
          value: 'reliever',
        },
      ]
    },
    exerciseProgramOptions() {
      return this[ExerciseProgramGetterNames.exercisePrograms].map(exercise => ({
        id: exercise.id,
        title: exercise.title,
      }))
    },
    ...mapGetters(ModuleNames.exerciseProgram, [ExerciseProgramGetterNames.exercisePrograms]),
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.patientInformationForm.resetValidation()
    })
  },
  methods: {
    getCareGiverName(cg) {
      if (!cg) {
        return ''
      }
      return `${cg.firstName} ${cg.lastName}`
    },
    getPatientInfoValue(prop) {
      // if (prop == PatientInformationKeys.CareGiver) {
      //   return this.getCareGiverName(this[prop])
      // }
      return this[prop]
    },
    updatePatientInfo(prop, event) {
      this.$emit(`update:${prop}`, event)
    },
    updateFormValidation(event) {
      this.$emit('update:patientInformationIsValid', event)
    },
  },
}
